import { MultiSelectValue } from "../components/MultiSelect"

export class CustomConfig {
    fields?: Field[]
    rechnungFormats?: string[]
    additionalHints?: string[]
    units?: MultiSelectValue[]
    paymentMeans?: PaymentMeans
    invoiceType?: MultiSelectValue[]
    attachments?: string[]
    customUploadAdvices?: string[]
    skontoAlsText = false
    decimalPrecisionForAmount?: number
    steuerberechnung?: string
}

export class PaymentMeans {
    defaultValue?: string
    options?: MultiSelectValue[]
}

export class Field {
    id?: string
    defaultValue?: string
    disabled = false
    category?: string
    hint?: string
    placeholder?: string
    required?: boolean
    label?: string
    hide?: boolean
    pattern?: string
}
